import Config from "@/config/config.js";
import AsyncUtils from "@/utils/asyncUtils.js";
import { handleError } from "./index.service.js";
import backendService from "./index.service.js";
import AuthService from "@services/auth.service.js";
import State, { STATE, InvitationState } from "@state";
import { sha256 } from "@/utils/crypto.js";
import { getSession } from "@/hooks/useSession.js";

const { OshimedBackend, OshimedAPI } = backendService;

const getUserInfo = async (userId) => {
  console.log(
    "=== Service: getUserInfo called with ID === user.service.js === key: 876543 ==="
  );
  console.dir(userId, { depth: null, colors: true });
  console.log("=================================");
  try {
    const url = `${Config.BACKEND_URL}/user/${userId}`;
    console.log("Request URL:", url);
    const response = await OshimedBackend.get(url);
    console.log(
      "=== Service: API response === user.service.js === key: 210987 ==="
    );
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");
    if (!response.data) {
      console.warn("API returned empty response");
      return null;
    }
    return response.data;
  } catch (error) {
    console.error("Service error in getUserInfo:", error);
    console.error("Error details:", error.response?.data || error.message);
    return handleError(error, 456789);
  }
};

const updateUserInfo = async (userId, payload = {}) => {
  console.log(
    "=== Service: updateUserInfo called === user.service.js === key: 445566 ==="
  );
  console.log("userId:", userId);
  console.log("payload:", payload);
  console.log("=================================");

  if (!userId || !payload || Object.keys(payload).length === 0) {
    const err = {
      success: false,
      message: "Parametri mancanti: userId o payload vuoto",
      errorCode: "missing-params",
      errorKey: 778899,
    };
    console.warn("updateUserInfo warn:", err);
    return err;
  }

  try {
    const url = `${Config.BACKEND_URL}/user/${userId}`;
    console.log("Request URL (PUT):", url);

    const response = await OshimedBackend.put(url, payload);

    console.log(
      "=== Service: API response === user.service.js === key: 556677 ==="
    );
    console.dir(response.data, { depth: null, colors: true });
    console.log("=================================");

    if (!response.data) {
      console.warn("API returned empty response on update");
      return {
        success: false,
        message: "Empty response",
        errorCode: "empty-response",
        errorKey: 990011,
      };
    }
    return response.data;
  } catch (error) {
console.log('=== error === user.service.js === key: 137435 ===');
console.dir(error, { depth: null, colors: true })
console.log('=================================');
    return handleError(error, 112244);
  }
};



const UserService = {
  getUserInfo,
  updateUserInfo,

};

export default UserService;
